var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground},scopedSlots:_vm._u([{key:"links",fn:function(props){return [(_vm.logged_user_role == 'Admin')?_c('sidebar-item',{attrs:{"opened":"","link":{
            name: _vm.locale.work_shifts,
            icon: 'fa fa-clock-o',
            path: '/components/working-hours',
          }}},[_c('sidebar-item',{attrs:{"link":{
            name: _vm.locale.workers,
            // path: '/components/working-hours?workers',
            path: '/examples/user-management/list-users?reports',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.locale.projects,
            // path: '/components/working-hours?projects',
            path: '/components/projects?reports',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.locale.clients,
            // path: '/components/working-hours?clients',
            path: '/components/clients?reports',
          }}})],1):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: _vm.locale.dashboard,
            icon: 'now-ui-icons design_app',
            path: '/dashboard',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: _vm.locale.projects,
            icon: 'now-ui-icons ui-1_calendar-60',
            path: '/components/projects',
          }}}),(_vm.logged_user_role == 'Admin')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.locale.clients,
            icon: 'now-ui-icons business_badge',
            path: '/components/clients',
          }}}):_vm._e(),(_vm.logged_user_role == 'Admin')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.locale.project_managers,
            icon: 'now-ui-icons business_badge',
            path: '/components/clientWorkers',
          }}}):_vm._e(),(_vm.logged_user_role == 'Admin')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.locale.workers,
            path: '/examples/user-management/list-users',
            icon: 'now-ui-icons users_single-02',
          }}}):_vm._e(),(_vm.logged_user_role == 'Worker')?_c('sidebar-item',{attrs:{"link":{
            name: _vm.locale.Days_off,
            icon: 'now-ui-icons tech_watch-time',
            path: '/components/calendar',
          }}}):_vm._e(),(_vm.user_ag == null)?_c('sidebar-item',{attrs:{"link":{
            name: _vm.locale.companies,
            path: '/examples/company-management/list-companies',
            icon: 'now-ui-icons business_bank',
          }}}):_vm._e(),_c('user-menu')]}}])}),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('sidebar-share',{staticStyle:{"cursor":"pointer"},attrs:{"color":_vm.sidebarBackground,"fixed-navbar":_vm.fixedNavbar,"sidebarMini":_vm.sidebarMini},on:{"update:color":function($event){_vm.sidebarBackground=$event},"update:fixedNavbar":function($event){_vm.fixedNavbar=$event},"update:fixed-navbar":function($event){_vm.fixedNavbar=$event},"update:sidebarMini":function($event){_vm.sidebarMini=$event},"update:sidebar-mini":function($event){_vm.sidebarMini=$event}}}),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }